// extracted by mini-css-extract-plugin
export default {"landingSection":"LandingPage_landingSection__N1foN","content":"LandingPage_content__RXv9D","cta":"LandingPage_cta__jBibT","btnPrimary":"LandingPage_btnPrimary__8WL9G"};